const data = {
  title: 'Dealing with a death takes time',
  description:
    'The passing of a loved one can be difficult enough, so you may not feel ready to arrange a funeral. Our direct cremations let you sort the things that need to happen quickly, then organise a fitting farewell later.',
  callUs: {
    title: 'Want some inspiration?',
    description:
      'We’ve got lots of ideas for things you could do, and can point you towards the best places near you. Our team is always happy to help.',
    cta: 'Call us today',
  },
}

export default data
